<template>
  <div >

    <b-card class="card2" title="Filtre" no-body >
      <b-card-header header-tag="nav" class="custom-nav-filters ">
        <b-nav card-header   pills align="right" >                  
                  <b-nav-item class="custom-nav-item-filters" v-on:click="isfilterisvisible = !isfilterisvisible">
                      <div v-if="!isfilterisvisible && checked.length == 0 && checkedaccesibil.length == 0 && subchecked.length == 0 && searchkeyword.length < 1" v-b-toggle.collapse-1 @click="$emit('makemarkerinvisible')">
                        <b-icon-search></b-icon-search> Filtre si cautare
                      </div>
                      <div v-if="!isfilterisvisible  &&  (checked.length > 0 || checkedaccesibil.length > 0 || subchecked.length > 0 || searchkeyword.length >= 1)"  v-b-toggle.collapse-1 >
                        <b-icon-search></b-icon-search> Filtre - Rezultate: {{filteresult}}
                      </div>
                      <div v-if="isfilterisvisible && checked.length == 0 && checkedaccesibil.length == 0 && subchecked.length == 0" v-b-toggle.collapse-1 @click="$emit('makemarkervisible')">
                        <b-button aria-label="Close" class="close text-dark"><b-icon icon="x" font-scale="1"></b-icon></b-button>
                      </div>
                      <div v-if="isfilterisvisible  && (checked.length > 0 || checkedaccesibil.length > 0 || subchecked.length > 0 && searchkeyword.length < 1)" v-b-toggle.collapse-1>
                        <b-button aria-label="Close" class="close text-dark"><b-icon icon="x" font-scale="1"></b-icon></b-button>                        
                      </div>                                        
                  </b-nav-item>
         </b-nav>
      </b-card-header>
    </b-card>
    
    <b-collapse id="collapse-1" class="mt-2 custom-filters-container">
                <div class="container-xl custom-contact-container">
                    <div class="row">
                      <div class="col-xl-4">                        
                          <b-form inline @submit.prevent="hidefilterpane">
                            <b-form-input style="width: 500px" v-model="searchkeyword" @keyup="searchTimeOut()" size="sm"  placeholder="Cauta"></b-form-input>
                            <b-button size="sm"  variant="outline-secondary" @click="hidefilterpane(); sendfilters(checked, checkedaccesibil, subchecked, searchkeyword);"><b-icon icon="search"></b-icon></b-button>
                          </b-form>
                      </div>
                      <div class="col-xl-8 ">             
                                <fieldset class="group">
                                <ul class="checkbox">
                                    <li >
                                    <label style="color:green; font-weight: 500;" class="checkbox-label"><input switch type="checkbox" :value="tipaccesibil[0]" v-model="checkedaccesibil" v-on:change="sendfilters(checked, checkedaccesibil, subchecked, searchkeyword)" >{{tipaccesibil[0]}}</label>
                                    </li>
                                    <li >
                                    <label style="color:#dec210; font-weight: 500;" class="checkbox-label"><input switch type="checkbox" :value="tipaccesibil[1]" v-model="checkedaccesibil" v-on:change="sendfilters(checked, checkedaccesibil, subchecked, searchkeyword)" >{{tipaccesibil[1]}}</label>
                                    </li>
                                    <li >
                                    <label style="color:red; font-weight: 500;" class="checkbox-label"><input switch type="checkbox" :value="tipaccesibil[2]" v-model="checkedaccesibil" v-on:change="sendfilters(checked, checkedaccesibil, subchecked, searchkeyword)" >{{tipaccesibil[2]}}</label>
                                    </li>                                    
                                </ul>
                                </fieldset>
                      </div>                                            
                    </div>

                    <div class="row">                    
                        <div class="col-xl-6 custom-chechbox-container">
                                <h4 class="custom-filter-title">Categorie</h4>
                                <fieldset class="group">
                                <ul class="checkbox">
                                    <li v-for="(categorie, pk) in categories"  :key="pk" >
                                    <label class="checkbox-label"><input type="checkbox" :value="categorie.nume" v-model="checked" v-on:change="sendfilters(checked, checkedaccesibil, subchecked, searchkeyword)" >{{categorie.nume}}</label>
                                    </li>
                                </ul>
                                </fieldset>                    
                        </div>
                        <div v-if="subcategories"  class="col-xl-6 custom-chechbox-container">
                            <b-form-group label="Subcategorii">
                            <b-form-tags v-if="subcategories" v-model="subchecked" size="lg" @input="sendfilters(checked, checkedaccesibil, subchecked, searchkeyword)" add-on-change no-outer-focus class="mb-2" >
                                <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }" >
                                <ul v-if="tags.length > 0"  class="list-inline d-inline-block mb-2" >
                                    <li v-for="tag in tags" :key="tag" class="list-inline-item" >
                                    <b-form-tag
                                        @remove="removeTag(tag)"                                    
                                        :title="tag"
                                        :disabled="disabled"
                                        variant="primary"                                    
                                    >{{ tag }}</b-form-tag>
                                    </li>
                                </ul>
                                <b-form-select
                                    v-bind="inputAttrs"
                                    v-on="inputHandlers"

                                    :disabled="disabled || availableSubcategories.length === 0"
                                    :options="availableSubcategories"                                   
                                >
                                    <template v-slot:first>
                                    <option disabled value="">Alege subcategorie...</option>
                                    </template>
                                </b-form-select>
                                </template>
                            </b-form-tags>
                            </b-form-group>
                        </div>       
                    </div>
                </div>

              <b-card title="Filtre" no-body >
                <b-card-header header-tag="nav" class="custom-nav-filters">
                  <b-nav card-header  pills align="center" >                  
                  <b-nav-item class="custom-nav-item-filters" v-on:click="isfilterisvisible = !isfilterisvisible">
                      <div v-if="!isfilterisvisible && checked.length == 0 && checkedaccesibil.length == 0 && subchecked.length == 0" v-b-toggle.collapse-1 @click="$emit('makemarkerinvisible')">
                        <b-icon-filter></b-icon-filter>Filtre
                      </div>
                      <div v-if="!isfilterisvisible && searchkeyword.length >= 1 &&  (checked.length > 0 || checkedaccesibil.length > 0 || subchecked.length > 0)"  v-b-toggle.collapse-1 >
                        <b-icon-filter></b-icon-filter>Filtre - Rezultate: {{filteresult}}
                      </div>
                      <div v-if="isfilterisvisible && checked.length == 0 && checkedaccesibil.length == 0 && subchecked.length == 0" v-b-toggle.collapse-1 @click="$emit('makemarkervisible')">
                        <b-button size="sm" variant="success" ><b-icon-filter></b-icon-filter> Aplica Filtre - Rezultate: {{filteresult}}</b-button>
                        <b-button size="sm" variant="danger" @click="clearSelected()">Anuleaza filtre</b-button>
                      </div>
                      <div v-if="isfilterisvisible  && (checked.length > 0 || checkedaccesibil.length > 0 || subchecked.length > 0 && searchkeyword.length < 1)" v-b-toggle.collapse-1>
                        <b-button size="sm" variant="success" ><b-icon-filter></b-icon-filter> Aplica Filtre - Rezultate: {{filteresult}}</b-button>
                        <b-button size="sm" variant="danger" @click="clearSelected()">Anuleaza filtre</b-button>
                      </div>                                                                    
                  </b-nav-item>
                  </b-nav>
                </b-card-header>
              </b-card>
    </b-collapse>
    
  </div>
</template>

<script>
export default {
  name: 'NavFilters',
  props: {
       categories: {Object},
       subcategories: {Object},
       tipaccesibil: {Object},
       filteresult: {type: Number},
       clearfields: {type: Boolean}
  },
  data() {
      return {
        allcategories: [],
        checked: [],
        subchecked: [],
        checkedaccesibil: [],
        subcat: [],
        isfilterisvisible: false,
        isfitlerwindowvisible: false,
        currentPage : 1,
        perPage : 16,
        searchkeyword: '',
        timer : null
      }
    },
  methods: {
    sendfilters(categorie, tipaccesibil, subcategorie, keyword) {
      let filtersarray = {
        'keyword' : keyword,
        'categories': categorie,
        'tipaccesibil': tipaccesibil, 
        'subcategories': subcategorie
      }      
      this.$emit('changecategories', filtersarray)
    },    
    searchTimeOut() {  
          if (this.timer) {
              clearTimeout(this.timer);
              this.timer = null;
          }          
          this.timer = setTimeout(() => {
             this.sendfilters(this.checked, this.checkedaccesibil, this.subchecked, this.searchkeyword);
          }, 800);
      },
    clearSelected() {
      this.checked = []
      this.checkedaccesibil = []
      this.subchecked = []
      this.searchkeyword = ''
      this.$emit('clearselectedfields')
    },
    subcategorieForList() {
      return this.subcategories.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage,
      )
    },
    hidefilterpane() {
      this.isfilterisvisible = !this.isfilterisvisible
      this.$root.$emit('bv::toggle::collapse', 'collapse-1')      
      if (this.searchkeyword.length > 0) {        
        this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
         this.$gtag.event('filter toggled', { method: 'Website' })
      }
    }
  },
   mounted() {
        let res = []
        this.subcategories.forEach( function(s) {
            res.push(s.nume);
        })
        this.subcat = res
    },
    watch: {
        clearfields: function() {
                this.checked = []
                this.checkedaccesibil = []
                this.subchecked = []
                this.$emit('clearselectedfields')
        }        
    },
    computed: {
      availableSubcategories() {
        return this.subcat.filter(opt => this.subchecked.indexOf(opt) === -1)
    },
  }
}
</script>

<style lang="css" scoped>


@media screen and (max-width: 501px) {
    ul.checkbox li {
      display:inline-block;
      width:11em!important;
    }
}

.buton-danger {
  padding-left: 5px;
}

.card2 {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: none ;
    border-radius: 0.25rem;
}


.form-control {
  width: auto;
}
.form-inline {
    flex-flow: nowrap;
    width: auto;
}


.inline li {
  display: inline;  
}
.inline {
  padding-left: 5px;
  
}
.checkbox-label {
  padding-right: 5px;
  padding-left: 5px;
}

fieldset.group  { 
  margin: 0; 
  padding: 0; 
  padding: .125em; 
} 

fieldset.group legend { 
  margin: 0; 
  padding: 0; 
  font-weight: bold; 
  margin-left: 20px; 
  font-size: 100%; 
  color: black; 
} 


ul.checkbox  { 
  margin: 0; 
  padding: 0; 
  margin-left: 20px; 
  list-style: none; 
} 

ul.checkbox li input { 
  margin-right: .25em; 
} 

ul.checkbox li {
  display:inline-block;
  width:12em;
} 

ul.checkbox-subcategories li input { 
  margin-right: .25em; 
} 



ul.checkbox-subcategories  { 
  margin: 0; 
  padding: 0; 
  margin-left: 20px; 
  list-style: none; 
} 

.checkbox-subcategories li { 
  display:inline-block;
  width:12em;
}

.custom-chechbox-container {
  max-width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.custom-buttons-container {
  margin: 5px;
}
.custom-nav-filters {
  background-color: rgba(16, 121, 190, 0.02);
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: none;
}
.custom-nav-menu {
    background-color: rgba(16, 121, 190, 0.1);
    padding: 0.25rem 1.25rem;    
}

.custom-nav-menu a {
    display: block;
   
}
.custom-nav-item-menu {
  margin: 5px;
}

.custom-filters-container {
  background-color: rgba(0, 0, 0, 0.01);
  margin-top: 0.0rem !important;

}
.custom-nav-card {
  border: 0px solid rgba(0, 0, 0, 0.125);
}
.card-header-pills {
  margin-right: 0rem;
}
.nav-link {
  color: #212529;
  font-weight: 500;
  padding: 0;
}
.custom-contact-colors {
  background-color: rgba(0, 0, 0, 0.01);
}
.custom-contact-container {
    max-width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding-bottom: 5px;
    padding-top: 5px;            
}
.custom-contact-container p {
  color: #0a2240;
  margin-bottom: 5px;
}
.custom-contact-branding p {
  padding: 0px;
  color: #123d74;
}
.custom-contact-branding {
  padding-left: 0px;
}
.custom-font-motivation-green {
  color: #2faa3b;
  font-weight: bold;
}
.custom-font-motivation-blue {
  color: #123d74;
}
.custom-filter-title {
  text-align: center;
}
</style>
